import React, { Component } from 'react';
import {
  getCrossfadeImagesByName,
  updateCrossfadeImages,
} from '../../services/crossfadeService';
import { FormLabel, TextField, Button } from '@material-ui/core';
import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles';

class CrossfadeForm extends Component {
  state = {
    images: [],
    saving: false,
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    this.loadImages();
  }

  loadImages = async () => {
    const { name } = this.props.match.params;

    try {
      const result = await getCrossfadeImagesByName(name);

      const images = [...result.data[0].images]
        .sort((a, b) => a.position - b.position)
        .map((img) => ({
          position: img.position,
          src: img.src,
          srcWebp: img.srcWebp,
          srcWebpSm: img.srcWebpSm,
          alt: img.alt || '',
          selectedFile: null,
        }));

      this.setState({ images });
    } catch (ex) {
      if (ex.response && ex.response.status === 404) window.location = '/';
    }
  };

  theme = createMuiTheme({
    typography: {
      fontFamily: "'Nunito', sans-serif",
      fontSize: 11.5,
    },
    palette: {
      primary: {
        main: '#00CCFF',
      },
      secondary: {
        main: '#00CCFF',
      },
    },
  });

  fileSelectedHandler = (e, index) => {
    if (e.target.files.length === 0) return;

    const images = [...this.state.images];
    images[index] = {
      ...images[index],
      selectedFile: e.target.files[0],
      src: URL.createObjectURL(e.target.files[0]),
    };

    this.setState({ images });
  };

  altChangeHandler = (e, index) => {
    const images = [...this.state.images];
    images[index] = { ...images[index], alt: e.target.value };

    this.setState({ images });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const { name } = this.props.match.params;

    const setCrossfadeImages = async () => {
      const formData = new FormData();

      this.state.images.forEach((image) => {
        formData.append(`alt${image.position}`, image.alt || '');
        if (image.selectedFile)
          formData.append(
            `crossfadeImage${image.position}`,
            image.selectedFile,
            image.selectedFile.name
          );
      });

      this.setState({ saving: true });

      try {
        await updateCrossfadeImages(formData, name);
        window.history.back();
      } catch (ex) {
        this.setState({ saving: false });
        console.log(ex); // TODO: take out? axios interceptor should handle unexpected errors.
      }
    };
    setCrossfadeImages();
  };

  render() {
    const { images, saving } = this.state;
    const { name } = this.props.match.params;

    if (images.length === 0) return null; // Nothing to render until images are fetched.

    return (
      <ThemeProvider theme={this.theme}>
        <div className="margin-container-sm crud-form">
          <div className="crud-form-col">
            <h1>Crossfade Images Form &ndash; {name}</h1>

            <form className="membership-form" onSubmit={this.handleSubmit}>
              {images.map((image, index) => (
                <div className="input-wrap" key={image.position}>
                  <FormLabel
                    style={{ fontSize: '1.1rem', fontWeight: 600, color: '#000' }}
                  >
                    Image {image.position}
                  </FormLabel>
                  <div className="img-upload">
                    <Button
                      className="img-upload-button"
                      variant="contained"
                      component="label"
                    >
                      Choose Image
                      <input
                        type="file"
                        hidden
                        onChange={(e) => this.fileSelectedHandler(e, index)}
                      />
                    </Button>
                    <div className="image-preview">
                      <img src={image.src} alt="" />
                    </div>
                  </div>
                  <div style={{ fontSize: '.8rem', fontWeight: '600', color: '#007bff' }}>
                      Image aspect ratio: 1417 &times; 794 px
                  </div>
                  <TextField
                    value={image.alt}
                    onChange={(e) => this.altChangeHandler(e, index)}
                    id={`alt-${image.position}`}
                    name={`alt-${image.position}`}
                    type="text"
                    label="Alternative Text"
                    style={{ marginTop: '1.5em', width: '100%' }}
                  />
                  <div
                    style={{ fontSize: '.8rem', fontWeight: '600', color: '#007bff' }}
                  >
                    Describe the image to a visually impaired person as{' '}
                    <span style={{ textDecoration: 'underline' }}>precisely</span> as
                    possible with as{' '}
                    <span style={{ textDecoration: 'underline' }}>few words</span>{' '}
                    as possible.
                  </div>
                </div>
              ))}

              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={saving}
                style={{
                  borderRadius: '4px',
                  marginTop: '1.5em',
                  width: '200px',
                  height: '50px',
                  fontSize: '1.1rem',
                  fontWeight: '600',
                }}
              >
                Save
              </Button>
            </form>
          </div>
        </div>
      </ThemeProvider>
    );
  }
}

export default CrossfadeForm;
